import { create } from "zustand";

interface UIState {
  // Map of message ID to copied state
  copiedMessages: Record<string, boolean>;

  // Mark a message as copied
  setCopied: (messageId: string) => void;

  // Clear copied state for a message
  clearCopied: (messageId: string) => void;
}

export const useUIStore = create<UIState>((set) => ({
  copiedMessages: {},

  setCopied: (messageId) => {
    set((state) => ({
      copiedMessages: {
        ...state.copiedMessages,
        [messageId]: true,
      },
    }));

    // Auto-clear after 2 seconds
    setTimeout(() => {
      set((state) => ({
        copiedMessages: {
          ...state.copiedMessages,
          [messageId]: false,
        },
      }));
    }, 2000);
  },

  clearCopied: (messageId) =>
    set((state) => ({
      copiedMessages: {
        ...state.copiedMessages,
        [messageId]: false,
      },
    })),
}));
